import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ClientCodeEntry.css';

interface ClientCodeEntryProps {
  onCodeValid?: (code: string) => void;
}

const ClientCodeEntry: React.FC<ClientCodeEntryProps> = ({ onCodeValid }) => {
  const [code, setCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleCodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!code.trim()) {
      setError('Please enter a code');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Navigate to form with code
      navigate(`/form?code=${code.trim().toUpperCase()}`);
      
      // Notify parent if callback provided
      if (onCodeValid) {
        onCodeValid(code.trim().toUpperCase());
      }
    } catch (error) {
      setError('Failed to access form. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    setCode(value);
    setError(''); // Clear error when user types
  };

  return (
    <div className="client-code-entry">
      <div className="code-entry-container">
        <div className="code-entry-header">
          <h1>Enter Your Form Access Code</h1>
          <p>Please enter the 8-character code provided by your lawyer</p>
        </div>
        
        <form onSubmit={handleCodeSubmit} className="code-entry-form">
          <div className="code-input-group">
            <input
              type="text"
              value={code}
              onChange={handleCodeChange}
              placeholder="Enter code (e.g., ABC12345)"
              maxLength={8}
              className="code-input"
              required
              autoFocus
            />
            <button 
              type="submit" 
              disabled={isLoading || !code.trim()}
              className="access-btn"
            >
              {isLoading ? 'Loading...' : 'Access Form'}
            </button>
          </div>
        </form>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <div className="code-help">
          <h4>Need help?</h4>
          <ul>
            <li>Your lawyer should have provided you with an 8-character code</li>
            <li>The code is valid for 15 days from creation</li>
            <li>Contact your lawyer if you need a new code</li>
            <li>You can edit your form multiple times using the same code</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ClientCodeEntry; 